import React from "react";
import "./index.scss";

const Popup = ({ 
  isOpen, 
  onClose, 
  title, 
  message, 
  type = "success", // success, error, warning, info
  showIcon = true,
  buttonText = "Fermer",
  onButtonClick,
  showCancel = false,
  cancelButtonText = "Annuler",
  onCancelClick
}) => {
  if (!isOpen) return null;

  const getIcon = () => {
    switch (type) {
      case "success":
        return "✓";
      case "error":
        return "✕";
      case "warning":
        return "⚠";
      case "info":
        return "ℹ";
      default:
        return "✓";
    }
  };

  const getIconColor = () => {
    switch (type) {
      case "success":
        return "#4CAF50";
      case "error":
        return "#f44336";
      case "warning":
        return "#ff9800";
      case "info":
        return "#2196F3";
      default:
        return "#4CAF50";
    }
  };

  const handleButtonClick = () => {
    if (onButtonClick) {
      onButtonClick();
    } else {
      onClose();
    }
  };

  const handleCancelClick = () => {
    if (onCancelClick) {
      onCancelClick();
    } else {
      onClose();
    }
  };

  const handleOverlayClick = (e) => {
    if (e.target.className.includes('popup-overlay')) {
      onClose();
    }
  };

  return (
    <div className="popup-overlay" onClick={handleOverlayClick}>
      <div className="popup-content">
        {showIcon && (
          <div 
            className="popup-icon"
            style={{ backgroundColor: getIconColor() }}
          >
            {getIcon()}
          </div>
        )}
        <h2 className="popup-title">{title}</h2>
        <p className="popup-message">{message}</p>
        <div className="popup-buttons">
          {showCancel && (
            <button 
              className="popup-button popup-button-cancel"
              onClick={handleCancelClick}
            >
              {cancelButtonText}
            </button>
          )}
          <button 
            className="popup-button popup-button-primary"
            onClick={handleButtonClick}
          >
            {buttonText}
          </button>
        </div>
      </div>
    </div>
  );
};

export default Popup;
